<template>
  <div id="consent" class="hidden">
    <div class="fill">
      {{$t('message')}}
      <router-link to="privacy-policy">
        {{$t('link_text')}}
      </router-link>
    </div>
    <button class="btn btn-sm btn-primary" v-on:click="giveConsent">
      {{$t('accept')}}
    </button>
  </div>
</template>

<i18n>
en:
  message: By using this site you agree to the use of cookies for analytics
    and personalized content.
  link_text: Read our privacy policy
  accept: Got it!
de:
  message: Mit der Nutzung dieser Webseite erklären Sie, dass Sie der Nutzung
    von Cookies zur Verbesserung und Personalisierung unseres Angebotes zustimmen.
  link_text: Lesen Sie unsere Datenschutzerklärung
  accept: Akzeptieren
</i18n>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {

    };
  },
  mounted() {
    const form = document.getElementById('consent');
    this.timeoutUntilMatomoSet((matomo) => {
      /* detect bots and automatically consent to cookies */
      if (/bot|google|baidu|bing|msn|duckduck|teoma|slurp|yandex/i.test(navigator.userAgent)) {
        matomo.rememberConsentGiven();
      } else if (!matomo.hasRememberedConsent()) {
        /* show cookie consent banner */
        form.classList.remove('hidden');
      }
    });
  },
  methods: {
    giveConsent: function giveConsent() {
      this.$matomo.rememberConsentGiven();
      const form = document.getElementById('consent');
      form.classList.add('hidden');
    },
    timeoutUntilMatomoSet: function timeoutUntilMatomoSet(action, counter = 0) {
      if (this.$matomo) {
        action(this.$matomo);
      } else if (counter < 100) {
        setTimeout(() => {
          this.timeoutUntilMatomoSet(action, counter + 1);
        }, 10);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  #consent {
    display: flex;
    position: fixed;
    z-index: 99;
    background-color: #fafafa;
    bottom: 0px;
  }

  .fill {
    flex-grow: 1;
  }

  @media (min-width: 440px) {
    #consent {
      width: 400px;
      padding: 20px;
      margin: auto auto 30px 30px;
      border-radius: 3px;
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);

      button {
        margin: auto 0 0 5px;
      }
    }
  }

  @media (max-width: 440px) {
    #consent {
      width: 100%;
      margin: 0;
      padding: 5px;

      button {
        margin: auto 0 auto 5px;
      }
    }
  }

  .hidden {
    display: none !important;
  }

  button {
    height: 32px;
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CookieConsent.vue